import { render, staticRenderFns } from "./RecoverPassword.vue?vue&type=template&id=28ded1b4&scoped=true"
import script from "./RecoverPassword.vue?vue&type=script&lang=ts"
export * from "./RecoverPassword.vue?vue&type=script&lang=ts"
import style0 from "./RecoverPassword.vue?vue&type=style&index=0&id=28ded1b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ded1b4",
  null
  
)

export default component.exports